import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '@/contexts/AuthContext';
import Loading from '@components/Loading';
import SecureChat from '@/components/SecureChat';

export const Route = createFileRoute('/secure/portal/')({
  component: Portal,
});

function Portal() {
  const { isLoading: authLoading } = useAuth();

  if (authLoading) return <Loading />;

  // Use fixed positioning to create a viewport-filling container independent of document flow.
  // This prevents keyboard-induced scroll issues on mobile - the chat container stays
  // in place regardless of what the browser does with document scroll.
  return (
    <div className="fixed inset-0 flex flex-col justify-center items-center p-2 bg-page-background">
      <SecureChat />
    </div>
  );
}
